import React from 'react'
import { LinearProgress } from '@mui/material'
import { Box, Flex, Text } from 'rebass'
import { useNewTranslation } from 'hooks'
import { theme } from 'theme'
import styled from 'particles/themes/styled'
import { MAX_APPROVE_CHUNK } from './ListApprovePopUp'

const ProgressBar = styled(LinearProgress)`
    &.MuiLinearProgress-root {
        height: 16px;
        border-radius: 14px;
    }
    &.MuiLinearProgress-colorPrimary {
        background-color: ${theme.colors.hawkesBlue};
    }
    & .MuiLinearProgress-barColorPrimary {
        background-color: ${theme.colors.dodgerBlue};
    }
`
interface ProgressProps {
    count: number
    total: number
}

const Progress: React.FC<ProgressProps> = ({ count, total }) => {
    const [t] = useNewTranslation()
    const progress = total === 0 ? 0 : (count / total) * 100

    return (
        <Box alignItems="center">
            <Box my={theme.spacing.xxs}>
                <Text color={theme.colors.governorBay} fontSize="24px" mb={theme.spacing.xxxxs}>
                    {t('submission.importList.approvingLoadingState')}
                </Text>
                <Text color={theme.colors.governorBay} fontSize="16px">
                    {t('submission.importList.approvingLoadingStateSubtitle', {
                        count: MAX_APPROVE_CHUNK > total ? total : count,
                    })}
                </Text>
            </Box>
            <Flex justifyContent="space-between" alignItems="center">
                <Box width="100%" pr={theme.spacing.xs}>
                    <ProgressBar variant="determinate" value={progress} />
                </Box>
                <Box mr={theme.spacing.xxs}>
                    <Text color={theme.colors.governorBay} fontSize="20px">{`${Math.round(progress)}%`}</Text>
                </Box>
            </Flex>
        </Box>
    )
}

export default Progress
